import React from 'react'
import './StatCards.css'
const StatCards = (prop) => {
  return (
    <div className='stat-card'>
      <div className='quantity'>
        {prop.quantity}
        <br/>
        <span className='stat-label'>{prop.title}</span>
      </div>

    </div>
  )
}

export default StatCards
